import React, { useContext, Suspense } from 'react'
import './CustomizePolicy.css'
import FlexView from 'react-flexview/lib'
import { isMobile, BrowserView, MobileView } from 'react-device-detect'
import { Container, Divider } from '@material-ui/core'
import { InsurancePurchaseContextStore } from '../../context/InsuracePurchaseContext'
import { TextDivider } from '../Core/TextDivier'
import {
  EventEmitterService,
  EventKey,
} from '../../services/EventEmitterService'
import { ContinueButton } from '../Core/Buttons/ContinueButton'
import { useLocation } from 'react-router-dom'
import { isInFlow, isUK } from '../../services/utils'
import { BottomSheetPolicySummary } from './BottomSheetPolicySummary'
import { IsCommercialPopup } from '../PopUps/IsCommercialPopup'
import { GetAQuotePopup } from '../Quote/GetAQuotePopup'
import ViolationsService from '../../services/ViolationsService'
import { SessionService } from '../../services/SessionService'
import { lazyWithPreload } from '../../utilities/RLazyLoading'
import {
  FirebaseService,
  FirebaseConfigKey,
} from '../../services/FirebaseService'
import { COUNTRIES } from '../../Constants'
import LocalizationService from '../../services/LocalizationService'
import insuranceApi from '../../api/insurance.api'
import { BuyingInsuranceContextStore } from '../../context/BuyingInsuranceContext'
import { CustomizeOperatorsSection } from './CustomizePolicySections/CustomizeOperatorsSection'
import { CustomizeCoverageType } from './CustomizePolicySections/CustomizeCoverageType'
import { CustomizeUASSection } from './CustomizePolicySections/CustomizeUASSection'
import { InsuranceBillingPeriod } from '../../models/insurance-models/InsuranceBillingPeriodModel'
import { CustomizeAdditionalCoverageSection } from './CustomizePolicySections/CustomizeAdditionalCoverageSection'
import { Experiment, Variant } from 'react-optimize'
import { WhatsCoveredSummarySection } from './SummarySection/WhatsCoveredSummarySection'
import { GuidelinesSummarySection } from './SummarySection/GuidelinesSummarySection'
import DataLayerService from '../../services/DataLayerService'

const CustomizeAutoRenew = lazyWithPreload(() =>
  import('./CustomizePolicySections/CustomizeAutoRenew').then((module) => ({
    default: module.CustomizeAutoRenew,
  }))
)
const CustomizeAdditionalInsuredSection = lazyWithPreload(() =>
  import('./CustomizePolicySections/CustomizeAdditionalInsuredSection').then(
    (module) => ({ default: module.CustomizeAdditionalInsuredSection })
  )
)
const CustomizePolicyStartingDate = lazyWithPreload(() =>
  import('./CustomizePolicySections/CustomizePolicyStartingDate').then(
    (module) => ({ default: module.CustomizePolicyStartingDate })
  )
)
const CustomizeLiabilitySection = lazyWithPreload(() =>
  import('./CustomizePolicySections/CustomizeLiabilitySection').then(
    (module) => ({ default: module.CustomizeLiabilitySection })
  )
)
const CustomizeHullSection = lazyWithPreload(() =>
  import('./CustomizePolicySections/CustomizeHullSection').then((module) => ({
    default: module.CustomizeHullSection,
  }))
)

export const CustomizePolicy = () => {
  const offersContext = useContext(BuyingInsuranceContextStore)
  const location = useLocation()

  const onContinue = () => {
    EventEmitterService.dispatch(EventKey.FLOW_CUSTOMIZE_FINISH)
    var price = offersContext.pricebreakdown.price.toFixed(2)
    DataLayerService.pushToDataLayer({
      event: `customize-policy-finish`,
      price: price,
    })
  }

  return (
    <React.Fragment>
      {isMobile && (
        <TextDivider>
          <div className="text-title bold blue">
            {LocalizationService.STRINGS.customize} plan
          </div>
        </TextDivider>
      )}

      <Container maxWidth="md">
        <Suspense fallback={<div />}>
          {!isMobile && (
            <FlexView className="space-between">
              <div className="text-title bold blue margin-top-basic main-title">
                {LocalizationService.STRINGS.customize} Policy
              </div>
              <CustomizePolicyStartingDate />
            </FlexView>
          )}

          {isMobile && <CustomizePolicyStartingDate />}
          <Divider />
        </Suspense>

        {FirebaseService.getValue(FirebaseConfigKey.COUNTRY) ==
          COUNTRIES.UK && (
          <>
            <CustomizeCoverageType />
            <Divider />
          </>
        )}

        <Suspense fallback={<div />}>
          <CustomizeLiabilitySection />
          <Divider />

          {isUK() && (
            <>
              <CustomizeUASSection />
              <Divider />
            </>
          )}
        </Suspense>

        <Suspense fallback={<div />}>
          <CustomizeHullSection />
          <Divider />

          {FirebaseService.getValue(FirebaseConfigKey.COUNTRY) !=
            COUNTRIES.UK && (
            <>
              <Divider />
              <CustomizeAdditionalInsuredSection />
              {/* {insurancePurchaseContext.selectedOption.billingPeriod == InsuranceBillingPeriod.YEAR && <>
                            <Divider />
                            <CustomizeAutoRenew />
                        </>} */}
            </>
          )}

          {FirebaseService.getValue(FirebaseConfigKey.COUNTRY) ==
            COUNTRIES.UK && (
            <>
              <Divider />
              <CustomizeOperatorsSection />
            </>
          )}
        </Suspense>
      </Container>

      <div className="margin-top-basic">
        <WhatsCoveredSummarySection />
        <GuidelinesSummarySection />
      </div>

      <BrowserView>
        {isMobile && (
          <BottomSheetPolicySummary title={'Continue'} onClick={onContinue} />
        )}
        {!isMobile && isInFlow(location.pathname) && (
          <FlexView
            vAlignContent={'center'}
            className="margin-top-small margin-bottom-basic">
            <ContinueButton onClick={onContinue} />
            {/* <div className="margin-left-12">
                        {!location.pathname.startsWith('/proposal') && <GetAQuotePopup />}
                    </div> */}
          </FlexView>
        )}
      </BrowserView>
      <MobileView>
        <BottomSheetPolicySummary title={'Continue'} onClick={onContinue} />
      </MobileView>

      <IsCommercialPopup />
    </React.Fragment>
  )
}
